import {
    IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle,
    IonChip, IonCol, IonContent, IonDatetime, IonGrid, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent,
    IonItem, IonLabel, IonLoading, IonPage, IonPopover, IonRefresher, IonRefresherContent, IonRow,
    IonTitle, IonToast, IonToolbar, useIonAlert, useIonViewDidEnter
} from '@ionic/react';
import { Buffer } from 'buffer';
import { arrowBack, printOutline, search } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { mesaGerarCupom, urlBaseCore } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import './TotemHistorico.css';

const TotemHistorico: React.FC = () => {
    const history = useHistory();
    const [showToast, setShowToast] = useState(false);
    const [textToast, setTextToast] = useState("");
    const [mostartAlerta] = useIonAlert();
    const [arrayPedidos, setArrayPedidos] = useState<any>([]);
    const [desabilitarInfiniteScroll, setDesabilitarInfiniteScroll] = useState(false);
    const [pedidopk, setPedidopk] = useState("");
    const [pedidosk, setPedidosk] = useState("");
    const [pedidogsi2sk, setPedidogsi2sk] = useState("");
    const [pesquisaData, setPesquisaData] = useState<any>("Pesquisar");
    const [showLoadingPage, setShowLoadingPage] = useState(true);
    const [showModalData, setShowModalData] = useState(false);
    const popover = useRef<HTMLIonPopoverElement>(null);
    const contentRef = useRef<HTMLIonContentElement | null>(null);
    const { loja } = useContext(MessageContext);
    const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
    const [filtroPesquisa, setFiltroPesquisa] = useState<any>("");

    useEffect(() => {
        carregarHistorico("");
        setPesquisaData('Pesquisar');
    }, []);

    useIonViewDidEnter(() => {
        setEsconderMenu(true);
    });

    function doRefresh(event: any) {
        carregarHistorico(filtroPesquisa);
        setTimeout(() => {
            event.detail.complete();
        }, 1200);
    }

    async function gerarCupom(pedidoid: any) {
        var token: string = "";
        var tkn = localStorage.getItem("token");
        if (typeof tkn === "string") { token = tkn; }

        try {
            setShowLoadingPage(true);
            const resp = await fetch(mesaGerarCupom.url.replaceAll("{id}", pedidoid.replaceAll(/#/g, "%23")), {
                method: mesaGerarCupom.method,
                headers: [["token", token]],
                credentials: 'include'
            });
            const result = await resp.json();
            if (result) {
                console.log("result", result);

                mostartAlerta({
                    backdropDismiss: false,
                    header: 'Gerar Cupom',
                    message: '<strong>Cupom</strong> foi gerado com sucesso.',
                    buttons: [
                        {
                            text: 'Cancelar',
                            role: 'cancel',
                        },
                        {
                            text: 'Visualizar',
                            cssClass: 'primary',
                            handler: () => {
                                window.open(result, '_blank');
                            }
                        }
                    ],
                    onDidDismiss: (e) => console.log('did dismiss'),
                });
            }
        } catch (error) {
            console.error("Erro ao gerar cupom:", error);
            setTextToast("Ocorreu um erro ao gerar o cupom.");
            setShowToast(true);
        } finally {
            setShowLoadingPage(false);
        }
    }

    function preencheCard(value: any, indice: any) {
        return (
            <IonCard className={"cardComanda"} key={"totemhist" + indice + value.pk}>
                <IonCardHeader id={value.pk} style={{ margin: 0 }}>
                    <IonItem style={{ width: "100%", borderRadius: "10px 10px 0 0" }} lines="none">
                        <IonLabel style={{ margin: 0 }} slot="start">{value.clienteNome || 'Cliente Totem'}</IonLabel>
                    </IonItem>
                </IonCardHeader>
                <IonCardContent>
                    <IonGrid>
                        <IonRow key={"totemrowtotal" + indice}>
                            <IonCol>
                                <div className="operacao" style={{ alignItems: 'center' }}>
                                    <IonLabel style={{ fontSize: "18px", fontWeight: 'bold' }}>TOTAL</IonLabel>
                                    <IonLabel style={{ fontSize: "18px", fontWeight: 'bold' }}>R$ {value.valorTotal || "0,00"}</IonLabel>
                                </div>
                            </IonCol>
                        </IonRow>

                        {value.tipoRetirada && (
                            <IonRow key={"totemrowretirada" + indice}>
                                <IonCol>
                                    <div className="operacao">
                                        <IonLabel className="operacaoTexto">Retirada</IonLabel>
                                        <IonLabel className="comandaTexto">{value.tipoRetirada}</IonLabel>
                                    </div>
                                </IonCol>
                            </IonRow>
                        )}

                        {value.formaPagamento && (
                            <IonRow key={"totemrowpag" + indice}>
                                <IonCol>
                                    <div className="operacao">
                                        <IonLabel className="operacaoTexto">Pagamento</IonLabel>
                                        <IonLabel className="comandaTexto">
                                            {Array.isArray(value.formaPagamento)
                                                ? value.formaPagamento.map((f: any) => f.pagamento || f.tipo).join(', ')
                                                : value.formaPagamento}
                                        </IonLabel>
                                    </div>
                                </IonCol>
                            </IonRow>
                        )}
                    </IonGrid>

                    <IonItem lines="none">
                        <IonChip style={{ fontSize: "18px", borderRadius: '8px' }} slot="end" color='primary' onClick={() => { gerarCupom(value.pk); }}>
                            <IonIcon icon={printOutline}></IonIcon>
                            <IonLabel>Cupom</IonLabel>
                        </IonChip>
                    </IonItem>
                </IonCardContent>
            </IonCard>
        );
    }

    const loadItens = () => {
        if (!arrayPedidos || arrayPedidos.length === 0) {
            return (
                <IonCard key="primeira">
                    <IonCardHeader key="primeiraheader">
                        <IonCardTitle>Neste momento não existe histórico.</IonCardTitle>
                        <IonCardSubtitle></IonCardSubtitle>
                    </IonCardHeader>
                    <IonCardContent></IonCardContent>
                </IonCard>
            );
        }

        return arrayPedidos.map((value: any, index: any, arr: any) => {
            const dataAnterior = arr[index - 1]?.dataCadastro;
            const dataAtual = value.dataCadastro;
            const dataAnteriorFormatada = dataAnterior ? new Date(dataAnterior).toLocaleString('pt-BR').substring(0, 10) : null;
            const dataAtualFormatada = dataAtual ? new Date(dataAtual).toLocaleString('pt-BR').substring(0, 10) : '';

            if (!dataAnteriorFormatada || dataAtualFormatada !== dataAnteriorFormatada) {
                return (
                    <div key={"divtotempai" + index}>
                        <IonCard className={"card"} key={"totemdata" + index}>
                            <IonCardHeader key={"headertotem" + index}>
                                <IonCardTitle key={"titulototem" + index}>
                                    <div key={"divtotem" + index} className={"cabecalho"}>{dataAtualFormatada}</div>
                                </IonCardTitle>
                            </IonCardHeader>
                        </IonCard>
                        {preencheCard(value, index)}
                    </div>
                );
            }
            return (
                <div key={"divtotempai" + index}>
                    {preencheCard(value, index)}
                </div>
            );
        });
    };

    async function carregarHistorico(data: any) {
        let token: string = "";
        const tkn = localStorage.getItem("token");
        if (typeof tkn === "string") { token = tkn; }

        let valor = data || "";
        if (valor) {
            valor = valor.replaceAll(/#/g, "%23");
        }

        try {
            const resp: Response = await fetch(
                urlBaseCore.url + "/ordens/historico?campo=data" +
                "&valor=" + valor +
                "&filtro=totem" +
                "&lojas=" + Buffer.from(loja).toString('base64'),
                {
                    method: urlBaseCore.method,
                    headers: [["token", token]],
                    credentials: 'include'
                }
            );
            const res = await resp.json();

            if (resp.status === 400 || resp.status === 401) {
                setShowLoadingPage(false);
                history.replace("/login/");
                return;
            }

            if (res && res.LastEvaluatedKey) {
                setPedidopk(res.LastEvaluatedKey.pk);
                setPedidosk(res.LastEvaluatedKey.sk);
                setPedidogsi2sk(res.LastEvaluatedKey.gsi2sk);
                setDesabilitarInfiniteScroll(false);
            } else {
                setDesabilitarInfiniteScroll(true);
            }

            setArrayPedidos(res.Items || []);
        } catch (err) {
            console.error("Erro ao carregar histórico totem:", err);
        } finally {
            setShowLoadingPage(false);
        }
    }

    async function carregarMaisPedidos($event: CustomEvent<void>) {
        await carregarMaisPedidosChamada();
        ($event.target as HTMLIonInfiniteScrollElement).complete();
    }

    async function carregarMaisPedidosChamada() {
        let token: string = "";
        const tkn = localStorage.getItem("token");
        if (typeof tkn === "string") { token = tkn; }

        let valor = filtroPesquisa || "";
        if (valor) {
            valor = valor.replaceAll(/#/g, "%23");
        }

        try {
            const res: Response = await fetch(
                urlBaseCore.url + "/ordens/historico?campo=data" +
                "&filtro=totem" +
                "&valor=" + valor +
                "&isk=" + pedidogsi2sk +
                "&pk=" + pedidopk +
                "&sk=" + pedidosk +
                "&lojas=" + Buffer.from(loja).toString('base64'),
                {
                    method: urlBaseCore.method,
                    headers: [["token", token]],
                    credentials: 'include'
                }
            );
            const pedidos = await res.json();

            if (res.status === 400 || res.status === 401) {
                history.replace("/login/");
                return;
            }

            if (pedidos.Items) {
                setArrayPedidos((prev: any) => [...prev, ...pedidos.Items]);

                if (pedidos.LastEvaluatedKey) {
                    setPedidopk(pedidos.LastEvaluatedKey.pk);
                    setPedidosk(pedidos.LastEvaluatedKey.sk);
                    setPedidogsi2sk(pedidos.LastEvaluatedKey.gsi2sk);
                    setDesabilitarInfiniteScroll(false);
                } else {
                    setPedidopk("");
                    setPedidosk("");
                    setPedidogsi2sk("");
                    setDesabilitarInfiniteScroll(true);
                }
            }
        } catch (err) {
            console.error("Erro ao carregar mais pedidos:", err);
        }
    }

    const openPopover = (e: any) => {
        popover.current!.event = e;
        setShowModalData(true);
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar color="danger">
                    <IonButtons slot="start">
                        <IonButton onClick={() => {
                            history.goBack();
                        }}>
                            <IonIcon slot="icon-only" icon={arrowBack} />
                        </IonButton>
                    </IonButtons>

                    <IonTitle>Histórico Totem</IonTitle>

                    <IonButton style={{ zIndex: '0', width: "170px", paddingRight: "10px" }} color="light" slot="end" size="small" onClick={e => { openPopover(e); }}>
                        <IonIcon style={{ color: "#BDBDBD", paddingRight: "10px", fontSize: "12px" }} icon={search} hidden={filtroPesquisa !== ""}></IonIcon>
                        <IonLabel style={{ textAlign: "left", overflow: "hidden", color: "#BDBDBD", fontSize: "12px" }}>{pesquisaData}</IonLabel>
                    </IonButton>
                </IonToolbar>
            </IonHeader>

            <IonContent fullscreen scrollEvents={true} ref={contentRef} color='light'>
                <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>

                <div className='TotemSlides'>
                    {loadItens()}
                </div>

                <IonInfiniteScroll
                    threshold="100px"
                    onIonInfinite={(e: CustomEvent<void>) => carregarMaisPedidos(e)}
                    position="bottom"
                    disabled={desabilitarInfiniteScroll}>
                    <IonInfiniteScrollContent loadingSpinner="dots" loadingText="Carregando mais pedidos..."></IonInfiniteScrollContent>
                </IonInfiniteScroll>

                <IonToast
                    isOpen={showToast}
                    position="middle"
                    onDidDismiss={() => setShowToast(false)}
                    message={textToast}
                    duration={3000}
                />

                <IonLoading
                    isOpen={showLoadingPage}
                    onDidDismiss={() => { setShowLoadingPage(false); }}
                    spinner='circles'
                />
            </IonContent>

            <IonPopover ref={popover}
                isOpen={showModalData}
                onDidDismiss={() => setShowModalData(false)}>
                <IonDatetime
                    presentation='date'
                    onIonChange={e => {
                        if (e.detail.value) {
                            let data = e.detail.value.toString().substring(0, 10);
                            const dataFormatada = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(Date.parse(data));
                            setPesquisaData(dataFormatada);
                            setFiltroPesquisa(data);
                            carregarHistorico(data);
                        }
                    }}
                />
            </IonPopover>
        </IonPage>
    );
};

export default TotemHistorico;
